import styles from './styles.module.scss';
import { FC } from 'react';

export const TextCell: FC<{ text?: string }> = ({ text }) => {
  return <div className={styles.textBold}>{text}</div>;
};
